import template from './cardRequestSuccess.html';
import controller from './cardRequestSuccess.controller';
import './cardRequestSuccess.scss';

let cardRequestSuccessComponent = {
  restrict: 'E',
  bindings: {
    onClose: '&',
    withoutManager:'<'
  },
  template,
  controller
};

export default cardRequestSuccessComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestSuccess/cardRequestSuccess.component.js